/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import axios from 'axios';
/**
 * WmapGetOrderDetails Input Action
 */
export class WmapGetOrderDetailsInput extends Msdyn365.CommerceEntityInput implements Msdyn365.IActionInput {
    //   Construct the input needed to run the action
    private orderDetailsAPIurl: string = '';
    private orderId: string = '';
    constructor(orderDetailsAPIurl: string, orderId: string) {
        super({ shouldCacheOutput: false, cacheObjectType: 'WmapGetOrderDetails', cacheKey: 'WmapGetOrderDetails' });
        this.orderDetailsAPIurl = orderDetailsAPIurl;
        this.orderId = orderId;
    }

    //   Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getOrderDetailsAPIurl = () => this.orderDetailsAPIurl;
    public getOrderId = () => this.orderId;
    public getCacheKey = () => `WmapGetOrderDetails`;
    public getCacheObjectType = () => 'WmapGetOrderDetails';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

//   Create a data model here or import one to capture the response of the action
export interface IWmapGetOrderDetailsData {
    text: string;
}

/**
 *   Use this function to create the input required to make the action call
 */
const createInput = (inputData: Msdyn365.ICreateActionContext<Msdyn365.IGeneric<Msdyn365.IAny>>): Msdyn365.IActionInput => {

    if (inputData.config && inputData.config.orderDetailsAPIurl) {
        if (inputData.requestContext && inputData.requestContext.query && inputData.requestContext.query.orderId) {
            // console.log("input data: " + inputData.requestContext.query.orderId);
            return new WmapGetOrderDetailsInput(inputData.config.orderDetailsAPIurl, inputData.requestContext.query.orderId);
        } else {
            return new WmapGetOrderDetailsInput(inputData.config.orderDetailsAPIurl, '');
        }
    }
    return new WmapGetOrderDetailsInput('', '');
};
/**
 *   Use this function to call your action and process the results as needed
 */
// tslint:disable: no-any
async function action(input: WmapGetOrderDetailsInput, ctx: Msdyn365.IActionContext): Promise<any> {
    const apiResponseUrl = ctx.requestContext.apiSettings.baseUrl;
    const orderDetailsApiUrl = input.getOrderDetailsAPIurl();
    const salesOrderId = input.getOrderId();
    const orderIdOun = ctx.requestContext.apiSettings.oun;
    const makeaPaymentLink = ctx.requestContext.app.config.wmapPageUrlSuffix?.toLowerCase();
    const pathName = ctx.requestContext && ctx.requestContext.url.requestUrl.pathname?.toLowerCase().replace(`/`, '');
    try {
        if (makeaPaymentLink === pathName) {
            const response = await axios.post(`${apiResponseUrl}/${orderDetailsApiUrl}`, {
                SalesId: salesOrderId
            }, {
                headers: {
                    // tslint:disable-next-line: object-literal-key-quotes
                    'oun': orderIdOun,
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } else {
            console.log('Make a Payment URL is not Configured or URL is not valid');
        }

    } catch (e) {
        //   will be removed after unit test and deployment on lower environment
        console.log('error for getting Sales Order Balance', e);
    }
}


export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<any>>action,
    //   Give your data action a unique id
    id: 'WmapGetOrderDetails',
    input: createInput
    //   Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
